import React, { useMemo } from "react";
import BatchActionTable from "@icoach/batchPayment/component/BatchActionTable";
import {
	getBatchActionConfigs,
} from "@icoach/batchPayment/staticData";
import { getDebitCreditCardRowsLabel } from "@icoach/batchPayment/component/DebitCreditCardRowsLabelTemplate";

const DebitListForCreditCard = ({ headerRow, list, sourceData, searchParams, dialogRef, refresh }) => {

	const batchActions = useMemo(
		() => (getBatchActionConfigs({ searchParams, sourceData, refresh })),
		// eslint-disable-next-line
		[]
	);


	const defaultHeaderRow = useMemo(
		() => {
			return getDebitCreditCardRowsLabel();
		},
		// eslint-disable-next-line
		[]
	);


	return <BatchActionTable batchActions={batchActions} list={list} headerRow={headerRow ? headerRow : defaultHeaderRow} dialogRef={dialogRef}
							 refresh={refresh} />;
};

export default DebitListForCreditCard;
